import * as React from 'react';

import { OrganisationContext } from 'contexts/organisation-context';
import {OrganisationContextValue} from "../contexts/organisation-context";

export function useOrganisation(): OrganisationContextValue {
  const context = React.useContext(OrganisationContext);

  if (!context) {
    throw new Error('useOrganisation must be used within a OrganisationProvider');
  }

  return context;
}
